// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"0bcdb56b","535":"6d5087cd"}[chunkId] + ".chunk.js";
};